export * from './generic-delete-dialog.module';
export * from './generic-delete-dialog.component';